import { z } from 'zod';

export const toolFormSchema = z.object({
  name: z.string()
    .min(1, 'El nombre es requerido')
    .max(255, 'El nombre debe tener máximo 255 caracteres'),
  code: z.string()
    .max(100, 'El código debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  type: z.string()
    .max(100, 'El tipo debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  description: z.string()
    .max(1000, 'La descripción debe tener máximo 1000 caracteres')
    .optional()
    .or(z.literal('')),
  location: z.string()
    .max(255, 'La ubicación debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  status: z.enum(['available', 'in_use', 'maintenance', 'damaged'])
    .default('available'),
  quantity: z.number()
    .int('Debe ser un número entero')
    .min(1, 'La cantidad debe ser al menos 1')
    .default(1),
  min_quantity: z.number()
    .int('Debe ser un número entero')
    .min(1, 'La cantidad mínima debe ser al menos 1')
    .default(1),
  cost_per_unit: z.number()
    .min(0, 'El costo debe ser mayor o igual a 0')
    .optional(),
  purchase_date: z.string()
    .optional()
    .or(z.literal('')),
  supplier: z.string()
    .max(255, 'El proveedor debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  maintenance_schedule: z.string()
    .max(1000, 'El programa de mantenimiento debe tener máximo 1000 caracteres')
    .optional()
    .or(z.literal('')),
  last_maintenance: z.string()
    .optional()
    .or(z.literal('')),
  notes: z.string()
    .max(2000, 'Las notas deben tener máximo 2000 caracteres')
    .optional()
    .or(z.literal('')),
  is_active: z.boolean().default(true),
});

export type ToolFormData = z.infer<typeof toolFormSchema>;
